import {autobind} from "core-decorators";
import {ApolloClient, createHttpLink, DefaultOptions, InMemoryCache, NormalizedCacheObject} from "@apollo/client";
import {setContext} from "@apollo/client/link/context";

import StageStore from "./StageStore";

@autobind
export default class Apollo {
  client: ApolloClient<NormalizedCacheObject>;
  stageStore: StageStore;

  constructor(stageStore: StageStore) {
    this.stageStore = stageStore;
    // Use a function for "uri" so that the url is read every time from the stage (which can change)
    const httpLink = createHttpLink({uri: () => this.stageStore.stage.graphqlHttpUrl});
    const authLink = setContext((_, {headers}) => {
      // get the authentication headers from local storage if it exists
      const authHeaders = JSON.parse(localStorage.getItem("authHeaders") || "{}");
      // return the headers to the context so httpLink can read them
      return {headers: {...headers, ...authHeaders}};
    });
    // Default options to disable the cache
    // https://stackoverflow.com/questions/47879016/how-to-disable-cache-in-apollo-link-or-apollo-client
    const defaultOptions: DefaultOptions = {
      watchQuery: {
        fetchPolicy: "no-cache",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
    };
    this.client = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
      defaultOptions,
    });
  }

  // Manually call this after your login or logout process
  // https://www.apollographql.com/docs/react/networking/authentication/#reset-store-on-logout
  async restartClient() {
    try {
      await this.client.resetStore();
    } catch (e) {
      console.warn("%cError on cache reset", "color: orange;", e.message);
    }
  }
}
